module.exports = {
    author: {
        avatar: ``,
        country: 'France',
        description: ``,
        email: `dev.jimmy.beldone@gmail.com`,
        location: `Lyon`,
        networks: {
            github: `https://github.com/JimmyBeldone/`,
            twitter: `https://twitter.com/@jimmy_dev`,
        },
        username: `Jimmy Beldone`,
    },
    business: {
        country: 'France',
        locality: 'Lyon',
        networks: {
            facebook: '',
            github: `https://github.com/JimmyBeldone/gatsby-reapt/`,
            instagram: '',
            pinterest: '',
            twitter: 'https://twitter.com/@jimmy_dev',
        },
        postal_code: '',
        region: '',
        street_address: '',
        title: 'Gatsby Reapt',
        url: 'https://github.com/JimmyBeldone/gatsby-reapt/',
    },
    copyright: `Copyright © ${new Date().getFullYear()}`,
};
